<template>
  <p-vue-input-text v-bind="$attrs" @input="onlyNumbers" />
</template>

<script>

export default {
  setup(props, { emit }) {
    
    return {
      onlyNumbers: event => {

        event.currentTarget.value = event.currentTarget.value.replace(/\D+/g, '')

        emit('update:modelValue', event.currentTarget.value)
      }
    }
  },
}
</script>